import { render, staticRenderFns } from "./BaseSearchBox.vue?vue&type=template&id=2910f80b&scoped=true"
import script from "./BaseSearchBox.vue?vue&type=script&lang=js"
export * from "./BaseSearchBox.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchBox.vue?vue&type=style&index=0&id=2910f80b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910f80b",
  null
  
)

export default component.exports